import { authReducer } from './auth.reducer'
import { automationProcessRegisterReducer } from './automation-process-register.reducer'
import { dashboardReducer } from './dashboard.reducer'
import { employeeReducer } from './employee.reducer'
import { expenseReducer } from './expense.reducer'
import { paymentReducer } from './payment.reducer'

export const appReducer = {
  login: authReducer,
  expense: expenseReducer,
  payment: paymentReducer,
  automationProcessRegister: automationProcessRegisterReducer,
  employee: employeeReducer,
  dashboard: dashboardReducer
}
